import { render, staticRenderFns } from "./SetupParamsDialog.vue?vue&type=template&id=fc8cb308&scoped=true"
import script from "./SetupParamsDialog.vue?vue&type=script&lang=js"
export * from "./SetupParamsDialog.vue?vue&type=script&lang=js"
import style0 from "./SetupParamsDialog.vue?vue&type=style&index=0&id=fc8cb308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8cb308",
  null
  
)

export default component.exports